import type { JSX } from 'react'
import type { ICard } from '../Card'

import React, { useState } from 'react'
import { AnimatedWrapper } from 'blocks/AnimatedWrapper'
import { CardAnimations } from '../Card.h'
import { BaseCard } from './BaseCard'

export type IAnimatedCard = Omit<ICard, 'transitionName'> & {
  transitionName: CardAnimations | CardAnimations[]
}

export const AnimatedCard = ({
  transitionName = CardAnimations.ScaleUp,
  ...props
}: IAnimatedCard): JSX.Element => {
  const [animation, setAnimation] = useState<boolean>(false)
  const cardRef = React.useRef<HTMLDivElement>(null)
  React.useEffect(() => {
    if (cardRef.current) {
      cardRef.current?.addEventListener('mouseover', () => setAnimation(true))
      cardRef.current?.addEventListener('mouseleave', () => setAnimation(false))
      return () => {
        cardRef.current?.removeEventListener('mouseover', () =>
          setAnimation(true)
        )
        cardRef.current?.removeEventListener('mouseleave', () =>
          setAnimation(false)
        )
      }
    }
  }, [])
  return (
    <AnimatedWrapper
      transitionName={transitionName}
      transitionTrigger={animation}
      duration={props.duration}
    >
      <BaseCard {...props} cardRef={cardRef} />
    </AnimatedWrapper>
  )
}
